"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgActionShowError: {
        id: 'action.show_error',
        defaultMessage: 'Show full error message',
    },
});
//# sourceMappingURL=actions.js.map